import React from "react"
import { findAvatar } from "components/avatar"

const UserAvatarTrail = ({ avatar, style }) => {
  const { component: Avatar } = findAvatar(avatar)
  return <Avatar style={style} />
}

export default UserAvatarTrail
